import { action } from "mobx";
import { GeoType } from "typings/flexFramework/FlexDefinitions";
import { DestinationAndTimestampData } from "stores/wizard/LastSearchData";

export abstract class DestinationModifier {
  protected constructor() {}

  @action
  public initializeDestination(
    regionType: GeoType,
    lastSearchData: DestinationAndTimestampData | undefined,
    destinationValue: string
  ) {
    function isGreaterThanCity(regionType: string) {
      return regionType === "continent" || regionType === "province_state" || regionType === "country";
    }

    isGreaterThanCity(regionType || !lastSearchData)
      ? this.updateDestination("", "")
      : this.updateDestinationFromCookie(
          destinationValue || "",
          lastSearchData?.destination?.regionID || "",
          lastSearchData?.destination?.countryCode || "",
          lastSearchData?.destination?.latLong || "",
          lastSearchData?.destination?.ttla || "",
          lastSearchData?.destination?.destinationID || "",
          lastSearchData?.destination?.hotelID || "",
          lastSearchData?.timestamp || 0
        );
  }

  @action
  public updateDestination(
    value: string,
    regionId: string,
    countryCode: string | undefined = "",
    latLong: string | undefined = "",
    ttla: string | undefined = "",
    destinationID: string | undefined = "",
    hotelID: string | undefined = "",
    timestamp: number | undefined = 0
  ) {
    this.updateDestinationFromCookie(value, regionId, countryCode, latLong, ttla, destinationID, hotelID, timestamp);
  }

  abstract updateDestinationFromCookie(
    value: string,
    regionID: string,
    countryCode: string,
    latLong: string,
    ttla: string,
    destinationId: string,
    hotelId: string,
    timestamp: number
  ): void;
}
